<template>
    <div>
        <b-card
                header="User List"
                header-text-variant="white"
                header-bg-variant="info"
        >
            <b-row>
                <b-col lg="6">
                </b-col>
                <b-col lg="6" class="text-right">
                    <b-form-input v-model="filter" placeholder="Type to Search" />
                </b-col>
            </b-row>
            <b-table bordered striped hover show-empty
                     :items="items"
                     :fields="fields"
                     :current-page="currentPage"
                     :per-page="perPage"
                     :filter="filter"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     @filtered="onFiltered"
            >
                <template v-slot:cell(action)="row">
                    <b-btn variant="info" :href="'/business/support/impersonate/' + row.item.id">
                        <i class="fa fa-user-secret"></i> Impersonate
                    </b-btn>
                </template>
            </b-table>

            <b-row>
                <b-col lg="6" >
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </b-col>
                <b-col lg="6" class="text-right">
                    Showing {{ perPage < totalRows ? perPage : totalRows }} of {{ totalRows }} results
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>

    export default {
        props: {
        },

        data() {
            return {
                items: [],
                totalRows: 0,
                perPage: 25,
                currentPage: 1,
                sortBy: null,
                sortDesc: false,
                filter: null,
                fields: [
                    {
                        key: 'firstname',
                        sortable: true,
                    },
                    {
                        key: 'lastname',
                        sortable: true,
                    },
                    {
                        key: 'username',
                        sortable: true,
                    },
                    {
                        key: 'email',
                        sortable: true,
                    },
                    'action'
                ]
            }
        },

        mounted() {
            this.loadData();
        },

        methods: {

            loadData() {
                console.log('load data called');
                axios.get('/business/support/impersonate/users')
                    .then(response => {
                        this.items = response.data;
                        this.totalRows = this.items.length;
                    });
            },

            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            }

        },

        computed: {
        }
    }
</script>

<style>

</style>